import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { MetadataProp } from 'src/app/models/metadata-prop-model';
import { SearchComboItemModel } from 'src/app/models/search-combo-item-model';
import { ConstantsService } from 'src/app/services/constants.service';
import { FormsService } from 'src/app/services/forms.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { QueryStateService } from 'src/app/services/query-state.service';
import { UserPreferencesService } from 'src/app/services/user-preferences.service';
import { environment } from 'src/environments/environment';
import { utcToZonedTime, formatInTimeZone } from 'date-fns-tz';
import { subDays } from 'date-fns';

@Component({
  selector: 'app-nav-top',
  templateUrl: './nav-top.component.html',
  styleUrls: ['./nav-top.component.css']
})
export class NavTopComponent implements OnInit {
  quickSearchItems: MenuItem[];
  helpInfoItems: MenuItem[];
  navItems: MenuItem[];
  loadSearchVisible: boolean = false;

  mdItems?: MetadataProp[];
  searchForm: FormGroup;

  constructor(private formSvc: FormsService, private actRouter: ActivatedRoute,
    private router: Router,
    private queryStateSvc: QueryStateService,
    private constants: ConstantsService, private mdSvc: MetadataService,
    private userPrefSvc: UserPreferencesService) {

    this.searchForm = this.formSvc.initSearchForm();

    this.navItems = [
      {
        label: 'Home',
        icon: 'fas fa-home',
        url: '#'
      },
      {
        label: 'Advanced Search',
        icon: 'fa-brands fa-searchengin',
        url: '/adv-search'
      }, {
        label: 'Load Saved Search',
        icon: 'pi pi-upload',
        command: () => { this.loadSearch(); }
      }, {
        label: 'Quick Searches',
        icon: 'fas fa-calendar',
        items: [
          {
            label: 'Today',
            icon: 'pi pi-calendar',
            command: () => { this.searchDays(0); }
          },
          {
            label: 'Yesterday',
            icon: 'pi pi-calendar',
            command: () => { this.searchDays(1); }
          },
          {
            label: 'Last 7 Days',
            icon: 'pi pi-calendar',
            command: () => { this.searchDays(6); }
          },
          {
            label: 'Last 30 Days',
            icon: 'pi pi-calendar',
            command: () => { this.searchDays(29); }
          }
        ]
      }, {
        label: 'Help & Info',
        icon: 'fas fa-circle-question',
        items: [
          {
            label: "User Guide",
            icon: 'pi pi-book',
            url: '/assets/APS-User-Manual.pdf',
            target: '_blank'
          },
          {
            label: 'Contact Public Document Room',
            icon: 'fas fa-book-open',
            url: 'https://www.nrc.gov/reading-rm/contact-pdr.html'
          },
          {
            label: 'Docket Number Reference',
            icon: 'pi pi-file',
            url: 'https://www.nrc.gov/reactors/operating/project-managers.html'
          },
          {
            label: 'Plugins, Viewers, and Other Tools',
            icon: 'pi pi-briefcase',
            url: 'https://www.nrc.gov/site-help/plug-ins.html'
          },
          {
            label: 'About ADAMS Public Documents',
            icon: 'fa-regular fa-file-lines',
            url: 'https://www.nrc.gov/reading-rm/adams.html'
          },
          {
            label: "ADAMS Public Search API",
            icon: 'fa fa-code',
            url: environment.devPortalUrl,
            target: '_blank'
          },
          {
            label: "ADAMS Public Search API Dev. Guide",
            icon: 'fa fa-code',
            url: '/assets/APS-API-Guide.pdf',
            target: '_blank'
          },
          {
            label: "Glossary",
            icon: 'fas fa-book-atlas',
            url: '/terms',
            target: '_blank'
          },
          {
            label: "NRC.gov",
            icon: 'fa-regular fa-building',
            url: 'https://www.nrc.gov',
            target: '_blank'
          },
          { separator: true },
          {
            label: 'Clear Preferences',
            icon: 'pi pi-trash',
            command: () => { this.clearPreferences(); }
          }
        ]
      },
    ]

    this.quickSearchItems = [
      {
        label: 'Today',
        icon: 'pi pi-calendar',
        command: () => { this.searchDays(0); }
      },
      {
        label: 'Yesterday',
        icon: 'pi pi-calendar',
        command: () => { this.searchDays(1); }
      },
      {
        label: 'Last 7 Days',
        icon: 'pi pi-calendar',
        command: () => { this.searchDays(6); }
      },
      {
        label: 'Last 30 Days',
        icon: 'pi pi-calendar',
        command: () => { this.searchDays(29); }
      }
    ];

    this.helpInfoItems = [
      {
        label: "User Guide",
        icon: 'pi pi-book',
        url: '/assets/APS-User-Manual.pdf',
        target: '_blank'
      },
      {
        label: 'Contact Public Document Room',
        icon: 'fas fa-book-open',
        url: 'https://www.nrc.gov/reading-rm/contact-pdr.html'
      },
      {
        label: 'Licenses & Docket Numbers',
        icon: 'pi pi-file',
        url: 'https://www.nrc.gov/reading-rm/adams/help-reference.html#ListofLicenses'
      },
      // {
      //   label: 'Docket Number Reference',
      //   icon: 'pi pi-file',
      //   url: 'https://www.nrc.gov/reactors/operating/project-managers.html'
      // },
      {
        label: 'Plugins, Viewers, and Other Tools',
        icon: 'pi pi-briefcase',
        url: 'https://www.nrc.gov/site-help/plug-ins.html'
      },
      {
        label: 'About ADAMS Public Documents',
        icon: 'fa-regular fa-file-lines',
        url: 'https://www.nrc.gov/reading-rm/adams.html'
      },
      {
        label: "ADAMS Public Search API",
        icon: 'fa fa-code',
        url: environment.devPortalUrl,
        target: '_blank'
      },
      {
        label: "ADAMS Public Search API Dev. Guide",
        icon: 'fa fa-code',
        url: '/assets/APS-API-Guide.pdf',
        target: '_blank'
      },
      {
        label: "Glossary",
        icon: 'fas fa-book-atlas',
        url: '/terms',
        target: '_blank'
      },
      {
        label: "NRC.gov",
        icon: 'fa-regular fa-building',
        url: 'https://www.nrc.gov',
        target: '_blank'
      },
      { separator: true },
      {
        label: 'Clear Preferences',
        icon: 'pi pi-trash',
        command: () => { this.clearPreferences(); }
      }
    ];
  }

  ngOnInit(): void {
    this.mdSvc.mdData$.subscribe(data => { this.mdItems = data; });
  }

  clearPreferences(): void {
    this.userPrefSvc.clearAll();
  }

  goHome() {
    window.location.href = '/';
    // this.router.navigate(['/']);
  }

  goAdvSearch() {
    let sf = this.formSvc.initSearchForm();

    this.queryStateSvc.updateFormData(sf.value);
    this.router.navigate(['adv-search']);
  }

  loadSearch() {
    //show popup to load the search and execute the search.
    this.loadSearchVisible = true;
  }

  executeLoadSearch(query: any) {
    this.loadSearchVisible = false;
    this.queryStateSvc.updateFormData(query);

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  closeLoadSearch() {
    this.loadSearchVisible = false;
  }

  executeQuickDateSearch(startDate: string, endDate?: string) {
    let dateOp = this.constants.date_operator_equals;
    if (endDate) {
      dateOp = this.constants.date_operator_between;
    }

    //get the property Item Id
    let i = this.mdItems?.find((m) => m.cogSearchKey == 'DateAdded') as MetadataProp;
    let pid = '';
    if (i) {
      pid = i.id;
    }

    let data: SearchComboItemModel = {
      isDate: true,
      dateOperator: dateOp,
      displayName: "Date Added",
      propertyItem: pid,
      endDate: endDate,
      startDate: startDate,
      keywords: ''
    };


    let p = this.formSvc.updateDateProp(data);

    const allArray = this.searchForm.get(this.constants.property_operator_all) as FormArray;
    allArray.clear();  // Clear the other items since we are using a pre-canned query.
    allArray.push(p);

    // Reset the skip count in case we are coming from a page result that is larger than our result.
    this.queryStateSvc.updateSkipCount(0);

    // Update the form values in the query state service which drives functions
    this.queryStateSvc.updateFormData(this.searchForm.value); // Will update/create the Search request in the Query Service.
    // console.log('form: ' + JSON.stringify(this.searchForm.value));

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  searchDays(daysBack: number) {

    // Always use EST for date calculations
    const estTimeZone = 'America/New_York';
    const today = formatInTimeZone(new Date(), estTimeZone, 'yyyy-MM-dd');
    console.log('EST Today: ' + today);

    console.log('Days Back: ' + daysBack);
    // Calculate the start date in EST
    const prevDay = formatInTimeZone(subDays(new Date(), daysBack), estTimeZone, 'yyyy-MM-dd');
    console.log('EST BackDays: ' + prevDay);

    let start = prevDay;
    let end = today;

    // If today or yesterday then just use the one date which will use equals operator.
    if (daysBack < 2) {
      this.executeQuickDateSearch(start);
    }
    else {
      this.executeQuickDateSearch(start, end);
    }

    // If today or yesterday then just use the one date which will use equals operator.
    if (daysBack < 2) {
      this.executeQuickDateSearch(start);
    }
    else {
      this.executeQuickDateSearch(start, end);
    }
  }
}
